<template>
    <div class="portlet">
        <div class="portlet-title">
            <div class="caption text-success">Acessibilidade</div>
        </div>
        <div class="">
            <div class="field-item even">
                    <p style="text-align: justify;">O termo acessibilidade significa incluir a pessoa com deficiência na participação de atividades como o uso de produtos, serviços e informações. Alguns exemplos são os prédios com rampas de acesso para cadeira de rodas e banheiros adaptados para deficientes.</p>

                    <p style="text-align: justify;">Na internet, acessibilidade refere-se principalmente às recomendações do WCAG (World Content Accessibility Guide) do W3C e no caso do Governo Brasileiro ao e-MAG (Modelo de Acessibilidade em Governo Eletrônico). O e-MAG está alinhado as recomendações internacionais, mas estabelece padrões de comportamento acessível para sites governamentais.</p>

                    <p style="text-align: justify;">Na parte superior do site;existe uma barra de acessibilidade onde se encontra atalhos de navegação padronizados e a opção para alterar o contraste. Essas ferramentas estão disponíveis em todas as páginas do portal.</p>
                    <p style="text-align: justify;">Os padrões de atalhos do governo federal são:</p>

                    <p style="text-align: justify;">Teclando-se Alt + 1 em qualquer página do portal, chega-se diretamente ao começo do conteúdo principal da página.</p>

                    <p style="text-align: justify;">Teclando-se Alt + 2 em qualquer página do portal, chega-se diretamente ao início do menu principal.</p>

                    <!--<p style="text-align: justify;">Teclando-se Alt + 3 em qualquer página do portal, chega-se diretamente em sua busca interna.</p> -->

                    <p style="text-align: justify;">No caso do Firefox, em vez de Alt + número, tecle simultaneamente Alt + Shift + número.</p>

                    <p style="text-align: justify;">Sendo Firefox no Mac OS, em vez de Alt + Shift + número, tecle simultaneamente Ctrl + Option + número.</p>

                    <p style="text-align: justify;">No Opera, as teclas são Shift + Escape + número. Ao teclar apenas Shift + Escape, o usuário encontrará uma janela com todas as alternativas de ACCESSKEY da página.</p>

                    <p style="text-align: justify;">Ao final desse texto, você poderá baixar alguns arquivos que explicam melhor o termo acessibilidade e como deve ser implementado nos sites da Internet.</p>

                    <p style="text-align: justify;">
                        <strong>Leis e decretos sobre acessibilidade:</strong>
                    </p>

                    <ul>
                        <li style="text-align: justify;">Decreto nº 5.296 de 02 de dezembro de 2004 (<a href="http://www.planalto.gov.br/ccivil_03/_Ato2004-2006/2004/Decreto/D5296.htm" target="_self" title="">http://www.planalto.gov.br/ccivil_03/_Ato2004-2006/2004/Decreto/D5296.htm</a>).</li>

                        <li style="text-align: justify;">Decreto nº 6.949, de 25 de agosto de 2009 - Promulga a Convenção Internacional sobre os Direitos das Pessoas com Deficiência e seu Protocolo Facultativo, assinados em Nova York, em 30 de março de 2007 (<a href="http://www.planalto.gov.br/ccivil_03/_ato2007-2010/2009/decreto/d6949.htm" target="_self" title="">http://www.planalto.gov.br/ccivil_03/_ato2007-2010/2009/decreto/d6949.htm</a>).</li>

                        <li style="text-align: justify;">Decreto nº 7.724, de 16 de Maio de 2012 - Regulamenta a Lei No 12.527, que dispõe sobre o acesso a informações (<a href="http://www.planalto.gov.br/ccivil_03/_ato2011-2014/2012/Decreto/D7724.htm" target="_self" title="">http://www.planalto.gov.br/ccivil_03/_ato2011-2014/2012/Decreto/D7724.htm</a>).</li>

                        <li style="text-align: justify;">Modelo de Acessibilidade de Governo Eletrônico (<a href="http://www.governoeletronico.gov.br/acoes-e-projetos/e-MAG" target="_self" title="">http://www.governoeletronico.gov.br/acoes-e-projetos/e-MAG</a>).</li>

                        <li style="text-align: justify;">Portaria nº 03, de 07 de Maio de 2007 - formato .pdf (35,5Kb) - Institucionaliza o Modelo de Acessibilidade em Governo Eletrônico – e-MAG (<a href="http://www.governoeletronico.gov.br/biblioteca/arquivos/portaria-no-03-de-07-05-2007" target="_self" title="">http://www.governoeletronico.gov.br/biblioteca/arquivos/portaria-no-03-de-07-05-2007</a>).</li>
                    </ul>
            </div>
        </div>
    </div>
    <!-- END FORM-->
</template>
<script>
export default{
    data() {
        return{
        }
    },
    components: {
    },
    computed: {
        // criação da função que pega os dados da rota ativa
    },
    ready() {
        // console.log($('.v-link-active span.title').html());
    },
    route: {
    }
}


</script>
<style>
.text-semconteudo{
	font-size: 14px;
}   
</style>


// WEBPACK FOOTER //
// acessiibilidade.vue?725a707c